import { DragAndDrop, IControl } from '@Common/Controls';

export interface IControlParameters {
    css?: any;
    className?: string;
    width?: string | number;
    height?: string | number;
    validator?: (value: any) => boolean;
    lazyLoadChildren?: boolean;
    isSimpleCheckMode?: boolean;
    sortable?: boolean;
    checkable?: boolean;
    checkBoxVisibilityComparer?: (data: any) => boolean;
    singleSelection?: boolean;
    allowContextMenu?: boolean;
    allowKeyBoardNavigation?: boolean;
    folderOnTop?: boolean;
    levelStyle?: any[];
    openByClick?: boolean;
    defaultLevelStyle?: any;
    comparer?: (item1, item2) => number;
    expandAll?: boolean;
    visibilityComparer?: (data) => boolean;
    cloneItems?: boolean;
    selectable?: boolean;
    canDrag?: boolean;
    scrollArea?: any;
    iScroll?: any;
    sort?: (a, b) => number;
    scopes?: string[];
}

export class BaseControl<TParam extends IControlParameters = any> implements IControl {
    protected _param: TParam;
    private _tag: any;
    protected _enabled: boolean;
    private _visible: boolean;
    protected _readonly: boolean;
    private _onDestroy: () => undefined;
    protected _dragAndDrop: DragAndDrop;
    protected _root: JQuery;

    constructor(param?: IControlParameters) {
        this._param = $.extend(
            {
                css: null,
                className: '',
                width: '100px',
                height: '100px'
            },
            param
        ) as any;

        this._enabled = true;
        this._visible = true;
        this._readonly = false;
        this._onDestroy = $.noop;
    }

    get dragAndDropControl() {
        return this._dragAndDrop;
    }

    protected _init() {}

    protected _applyDefaultParam() {
        if (this._root) {
            this._root.css({
                width: this._param.width,
                height: this._param.height
            });
            this._param.className && this._root.addClass(this._param.className);
            this._param.css && this._root.css(this._param.css);
        }
    }

    setCssStyle(css) {
        this._root.css(css);
    }

    state(enabled) {
        if (enabled !== undefined) {
            this._root.toggleClass('disabled', !enabled);
        }
    }

    adjust(width?, height?) {
        if (this._root && (width || height)) {
            width && this._root.outerWidth(width);
            height && this._root.outerHeight(height);
        }
    }

    enabled(data?: boolean): boolean {
        if (data === true) {
            this._enabled = data;
            this._root.removeClass('disabled');
            return this._enabled;
        } else if (data === false) {
            this._enabled = data;
            this._root.addClass('disabled');
            return this._enabled;
        } else {
            return this._enabled;
        }
    }

    readonly(data?: boolean): boolean {
        if (data === true) {
            this._readonly = data;
            this._root.addClass('readonly-control');
            return this._readonly;
        } else if (data === false) {
            this._readonly = data;
            this._root.removeClass('readonly-control');
            return this._readonly;
        } else {
            return this._readonly;
        }
    }

    tag(data?: any): any {
        if (data === undefined) {
            return this._tag;
        }
        this._tag = data;

        return data;
    }

    setError(message?) {
        this._root.addClass('invalid');
    }

    removeError() {
        this._root.removeClass('invalid');
    }

    getControl(): JQuery {
        return this._root;
    }

    visible(isVisible?: boolean): boolean {
        if (isVisible === undefined) {
            return this._visible;
        }

        this._visible = isVisible;
        this._root.toggleClass('hidden', this._visible === false);
    }

    destroy() {
        if (this._onDestroy) {
            this._onDestroy();
        }
        if (this._root) {
            this._root.remove();
        }
        this._root = null;
    }

    onDestroy(fn) {
        this._onDestroy = fn;
    }

    setState(enabled: boolean) {
        this.state(enabled);
    }
}
